(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-selector/assets/javascripts/race-selector.js') >= 0) return;  svs.modules.push('/components/racing/race-selector/assets/javascripts/race-selector.js');

'use strict';

const EmptyDataView = svs.racing.emptyDataView.EmptyDataView;
const {
  useEffect
} = React;
const {
  differenceInMinutes,
  isToday,
  isPast,
  parseISO,
  isFuture
} = dateFns;
const playUrl = svs.core.urlMapping.get('racing');
const Flag = svs.lb_ui.ReactFlag;
const {
  buildLocationFromRace,
  locationToUrl
} = svs.racing.navigation.location;
const {
  ReactIcon
} = svs.ui;
const Button = svs.ui.ReactButton;
const isDesktop = svs.core.detect.formfactor.desktop();
const {
  gameTypes,
  gameTypeToSubProductId,
  racePickerModes,
  subProductIdToGameType
} = svs.racing.common.constants;
const RaceSelectorItem = svs.racing.RaceSelectorItem;
const timeLineScrollLength = 4570;
let timeHeadClass;
let timerInterval;
let isDown = false;
let startX;
let scrollLeft;
let timeLine;
let arrowLeft;
let arrowRight;
const hourLabels = [];
for (let i = 0; i < 24; i++) {
  hourLabels.push("".concat(i.toString().padStart(2, '0'), ":00"));
}
const Jackpot = _ref => {
  let {
    jackpot
  } = _ref;
  const jackpotAmount = jackpot && jackpot.jackpots && jackpot.jackpots[0].jackpot;
  if (jackpotAmount) {
    return React.createElement("div", {
      className: "race-selector-item-jackpot"
    }, React.createElement("i", {
      className: "icon-default icon-jackpot"
    }), React.createElement("div", {
      className: "jackpot-text"
    }, "Jackpot ".concat(jackpotAmount, " kr")));
  }
  return null;
};
const ExtraMoney = _ref2 => {
  var _extraMoneyAmount;
  let {
    extraMoney
  } = _ref2;
  const userProductsArray = [];
  let extraMoneyAmount = 0;
  for (let index = 0; index < (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.length); index++) {
    for (let i = 0; i < extraMoney[index].jackpots.length; i++) {
      if (extraMoney[index].jackpots[i].userProduct !== gameTypeToSubProductId[gameTypes.TOPP5]) {
        userProductsArray.push(extraMoney[index].jackpots[i].userProduct);
        if (userProductsArray.length === 1) {
          extraMoneyAmount = extraMoney[index].jackpots[i].jackpot;
        }
      }
    }
  }
  const showExtraMoneyAmount = userProductsArray.length === 1 && ((_extraMoneyAmount = extraMoneyAmount) === null || _extraMoneyAmount === void 0 ? void 0 : _extraMoneyAmount.length);
  if (userProductsArray.length > 0) {
    return React.createElement("div", {
      className: "race-selector-item-jackpot"
    }, React.createElement("i", {
      className: "icon-default icon-money"
    }), React.createElement("div", {
      className: "jackpot-text"
    }, "".concat(showExtraMoneyAmount ? " Extrapengar ".concat(extraMoneyAmount, " kr") : ' Extrapengar')));
  }
  return null;
};
const HighFiveLabel = _ref3 => {
  let {
    raceSummary
  } = _ref3;
  return React.createElement("a", {
    className: "race-selector-high-five-label",
    href: "".concat(playUrl).concat(locationToUrl(buildLocationFromRace(raceSummary)))
  }, "High Five");
};
const getCurrentTimePosition = () => {
  const minutesToCurrentTime = differenceInMinutes(new Date(), new Date().setHours(0, 0, 0, 0));
  const pxToCurrentTime = minutesToCurrentTime * 3 + 250;
  return pxToCurrentTime;
};
const scrollToCurrentTime = () => {
  const timePosition = getCurrentTimePosition() - document.querySelector('.arena-max-width').clientWidth / 2;
  if (timeLine && timePosition) {
    timeLine.scrollTo({
      top: 0,
      left: timePosition,
      behavior: 'smooth'
    });
  }
};
const placeTimelineHead = currentDay => {
  const timeHeads = document.querySelectorAll('.timeline-head');
  let timePosition = getCurrentTimePosition();
  if (isPast(new Date(parseISO(currentDay)).setHours(24))) {
    timePosition = timeLineScrollLength;
  }
  if (isFuture(parseISO(currentDay))) {
    timePosition = 0;
  }
  for (let i = 0; i < timeHeads.length; i++) {
    const timeHead = timeHeads[i];
    timeHead.style.left = "".concat(timePosition, "px");
  }
  timeHeadClass = {
    display: 'block'
  };
};
const handleArrowClick = direction => {
  timeLine && timeLine.scrollTo({
    top: 0,
    behavior: 'smooth',
    left: direction === 'right' ? timeLine.scrollLeft + 360 : timeLine.scrollLeft - 360
  });
};
const onScrollAndResize = () => {
  if (timeLine) {
    const timeLineVisibleWidth = timeLine.offsetWidth;
    const endOfScroll = timeLineScrollLength - timeLineVisibleWidth;
    if (timeLine.scrollLeft === endOfScroll) {
      arrowRight.classList.add('u-hide');
    } else if (timeLine.scrollLeft === 0) {
      arrowLeft.classList.add('u-hide');
    } else {
      arrowRight.classList.remove('u-hide');
      arrowLeft.classList.remove('u-hide');
    }
  }
};
const onMouseDown = e => {
  if (e.target.classList.contains('race-selector-item') || e.target.classList.contains('race-selector-item-gait') || e.target.classList.contains('race-selector-item-race-number') || e.target.classList.contains('race-selector-item-status')) {
    return;
  }
  isDown = true;
  e.currentTarget.classList.add('active');
  startX = e.pageX - e.currentTarget.offsetLeft;
  scrollLeft = e.currentTarget.scrollLeft;
};
const onMouseLeaveAndUp = e => {
  isDown = false;
  e.currentTarget.classList.remove('active');
};
const onMouseMove = e => {
  if (!isDown) {
    return;
  }
  e.preventDefault();
  const x = e.pageX - e.currentTarget.offsetLeft;
  const walk = (x - startX) * 1;
  e.currentTarget.scrollLeft = scrollLeft - walk;
};
function timer() {
  timerInterval = setInterval(() => {
    placeTimelineHead();
  }, 60 * 1000);
}
const RenderItems = _ref4 => {
  let {
    racecard,
    getJackpot,
    getAllJackpots,
    racePickerMode
  } = _ref4;
  useEffect(() => {
    timeLine = document.querySelector('.picker-mode-timeline');
    arrowLeft = document.querySelector('.timeline-button-back .btn-left');
    arrowRight = document.querySelector('.timeline-button-back .btn-right');
    const currentDay = racecard[0].formattedDate;
    if (racePickerMode === racePickerModes.TIMELINE) {
      scrollToCurrentTime();
      if (isPast(parseISO(currentDay)) || isFuture(parseISO(currentDay))) {
        placeTimelineHead(currentDay);
      }
      if (isToday(parseISO(currentDay))) {
        timer();
      } else {
        clearInterval(timerInterval);
      }
    } else {
      clearInterval(timerInterval);
    }
  }, [racePickerMode, racecard]);
  useEffect(() => {
    if (racePickerMode === racePickerModes.TIMELINE) {
      let timer;
      timeLine.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          onScrollAndResize();
        }, 50);
      });
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          onScrollAndResize();
        }, 50);
      });
      return () => {
        timeLine.removeEventListener('scroll', onScrollAndResize);
        window.removeEventListener('resize', onScrollAndResize);
      };
    }
  }, [racePickerMode]);
  useEffect(() => {
    if (isDesktop && racePickerMode === racePickerModes.TIMELINE) {
      timeLine.addEventListener('mousedown', onMouseDown);
      timeLine.addEventListener('mouseleave', onMouseLeaveAndUp);
      timeLine.addEventListener('mouseup', onMouseLeaveAndUp);
      timeLine.addEventListener('mousemove', onMouseMove);
      return () => {
        timeLine.removeEventListener('mousedown', onMouseDown);
        timeLine.removeEventListener('mouseleave', onMouseLeaveAndUp);
        timeLine.removeEventListener('mouseup', onMouseLeaveAndUp);
        timeLine.removeEventListener('mousemove', onMouseMove);
      };
    }
  }, [racePickerMode]);
  const allJackpots = getAllJackpots();
  const cards = {};
  return React.createElement(React.Fragment, null, racePickerMode === racePickerModes.TIMELINE && React.createElement("div", {
    className: "timeline-button-back"
  }, React.createElement(Button, {
    className: "icon-button btn-icon-holder btn-left",
    onClick: () => handleArrowClick('left'),
    size: 100
  }, React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "menu-left",
    size: "100"
  })), React.createElement(Button, {
    className: "icon-button btn-icon-holder btn-right",
    onClick: () => handleArrowClick('right'),
    size: 100
  }, React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "menu-right",
    size: "100"
  }))), React.createElement("div", {
    className: "race-selector picker-mode-".concat(racePickerMode)
  }, React.createElement("div", {
    className: "timeline-inner"
  }, racePickerMode === racePickerModes.TIMELINE && React.createElement("div", {
    className: "timeline-ruler"
  }, hourLabels.map(value => React.createElement("div", {
    className: "timeline-hour",
    key: value
  }, React.createElement("span", null, value)))), React.createElement("div", {
    className: "race-selector-item-board"
  }, racecard.map((card, index) => {
    const countryCode = card.raceSummaries[0].countryCode;
    return React.createElement("div", {
      className: "race-selector-item-holder".concat(racecard.length === index + 1 ? ' last-item-holder' : ''),
      "data-index": index,
      key: card.track.name
    }, React.createElement("div", {
      className: "race-selector-item-holder-header"
    }, React.createElement("div", null, countryCode && React.createElement(Flag, {
      iso: countryCode,
      size: "100"
    }), "\xA0", " ".concat(card.track.name)), card.raceSummaries.map(raceSummary => {
      var _cards$raceSummary$me, _cards$raceSummary$me2;
      if (!cards[raceSummary.meeting.track.urlName]) {
        cards[raceSummary.meeting.track.urlName] = {
          raceWithExtraMoney: false
        };
      }
      const hasHighFive = raceSummary.draws.filter(draw => draw.gameType === gameTypes.TOPP5)[0];
      let presentExtraMoney = false;
      for (let i = 0; i < (allJackpots === null || allJackpots === void 0 ? void 0 : allJackpots.length); i++) {
        var _allJackpots$i, _allJackpots$i2, _allJackpots$i3, _allJackpots$i4;
        const filteredLength = (_allJackpots$i = allJackpots[i]) === null || _allJackpots$i === void 0 || (_allJackpots$i = _allJackpots$i.jackpots) === null || _allJackpots$i === void 0 ? void 0 : _allJackpots$i.filter(jackpot => jackpot.userProduct !== gameTypeToSubProductId[gameTypes.TOPP5]).length;
        if (((_allJackpots$i2 = allJackpots[i]) === null || _allJackpots$i2 === void 0 ? void 0 : _allJackpots$i2.jackpots.length) > 0 && ((_allJackpots$i3 = allJackpots[i]) === null || _allJackpots$i3 === void 0 || (_allJackpots$i3 = _allJackpots$i3.jackpots) === null || _allJackpots$i3 === void 0 ? void 0 : _allJackpots$i3.length) === filteredLength && raceSummary.raceId === ((_allJackpots$i4 = allJackpots[i]) === null || _allJackpots$i4 === void 0 ? void 0 : _allJackpots$i4.raceId)) {
          presentExtraMoney = true;
        }
      }

      if (racePickerMode !== ((_cards$raceSummary$me = cards[raceSummary.meeting.track.urlName]) === null || _cards$raceSummary$me === void 0 ? void 0 : _cards$raceSummary$me.originalRacePickerMode)) {
        cards[raceSummary.meeting.track.urlName].raceWithExtraMoney = false;
      }
      if ((_cards$raceSummary$me2 = cards[raceSummary.meeting.track.urlName]) !== null && _cards$raceSummary$me2 !== void 0 && _cards$raceSummary$me2.raceWithExtraMoney) {
        presentExtraMoney = false;
      } else if (presentExtraMoney) {
        cards[raceSummary.meeting.track.urlName].raceWithExtraMoney = true;
        cards[raceSummary.meeting.track.urlName].originalRacePickerMode = racePickerMode;
      }
      return React.createElement(React.Fragment, {
        key: "racejackpot_".concat(raceSummary.raceNumber, "_").concat(raceSummary.meeting.track.urlName, "_").concat(racePickerMode)
      }, isDesktop && hasHighFive && React.createElement(HighFiveLabel, {
        raceSummary: raceSummary
      }), isDesktop && hasHighFive && React.createElement(Jackpot, {
        jackpot: getJackpot(raceSummary.raceId)
      }), isDesktop && !hasHighFive && presentExtraMoney && React.createElement(ExtraMoney, {
        extraMoney: allJackpots === null || allJackpots === void 0 ? void 0 : allJackpots.filter(jackpot => jackpot.raceId === raceSummary.raceId)
      }));
    })), React.createElement("div", {
      className: "race-selector-card"
    }, racePickerMode === racePickerModes.TIMELINE && React.createElement("div", {
      className: "timeline-head",
      style: timeHeadClass
    }, React.createElement("div", {
      className: "timeline-head-line"
    })), card.raceSummaries.map(raceSummary => {
      let jackpotProp;
      let jackpotGameType;
      if (allJackpots !== undefined) {
        for (let i = 0; i < (allJackpots === null || allJackpots === void 0 ? void 0 : allJackpots.length); i++) {
          if (allJackpots[i].raceId === raceSummary.raceId) {
            jackpotProp = allJackpots[i];
            jackpotGameType = subProductIdToGameType[jackpotProp.jackpots[0].userProduct];
          }
        }
      }
      return React.createElement("a", {
        className: " ",
        href: "".concat(playUrl).concat(locationToUrl(buildLocationFromRace(raceSummary, jackpotGameType))),
        key: "racepicker_".concat(raceSummary.meeting.track.urlName, "_").concat(raceSummary.raceNumber)
      }, React.createElement(RaceSelectorItem, {
        jackpot: jackpotProp,
        racePickerMode: racePickerMode,
        raceSummary: raceSummary
      }));
    })));
  })))));
};
const RaceSelector = (racecard, racePickerMode, emptyDataViewLabel, getJackpot, getAllJackpots) => {
  if (!racecard || racecard.length === 0) {
    return React.createElement(EmptyDataView, {
      label: emptyDataViewLabel
    });
  }
  return React.createElement(RenderItems, {
    getAllJackpots: getAllJackpots,
    getJackpot: getJackpot,
    racecard: racecard,
    racePickerMode: racePickerMode
  });
};
svs.racing.RaceSelector = RaceSelector;

 })(window);